export default {
    
    login_step_one(credentials){
        return new Promise((resolve,reject) => {            
            axios.post('/login',{
                email: credentials.username,
                password: credentials.password,
            })
            .then(response =>{              
                resolve(response)
            })
            .catch(error=>{
                reject(error)
            })
        })
    },

    getSecretCode(context, data) {

        localStorage.setItem('secret_code', 12345)
        context.commit('getSecretCode', 12345)
 
    },

    destroyTokens(context, data) {

        localStorage.removeItem('secret_code')
        localStorage.removeItem('token')
        context.commit('destroyTokens')
    },


    getUserPermissions(token){
        return axios.get('/authpermissions', {
                headers: {
                    Authorization: "Bearer " + token
                }
            })
    },
    getUserInfo(){
        
        return axios.get('/authuser', {
                headers: {
                    Authorization: "Bearer " + token
                }
            })
    },
    forgetPassword(email) {
        const temp_token = localStorage.getItem('temp_token')
        return axios.post('/password/create', email, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + temp_token
            }
        })
    },
    resetPassword(data) {
        //const temp_token = localStorage.getItem('temp_token')
        console.log(data.token)
        return axios.post('/password/reset', { password: data.password, password_confirmation: data.password_confirmation,token:data.token}, {
            headers: {
                "Content-Type": 'application/json'
                //"Authorization": "Bearer " + data.token
            }
        })
    },
    login_step_two(secret){   
        const temp_token = localStorage.getItem('temp_token')      
        return new Promise((resole,reject) => { 
            //console.log(secret)           
                      
            axios.get('/login-verify/'+secret.code,
            {
                headers:{
                    Authorization: "Bearer " + temp_token
                }
            }
            )
            .then(response =>{
                resole(response)
            })
            .catch(error=>{
                reject(error)
            })
        })
    },

    disconnect_from_server(){
        return new Promise((resole,reject) => {           
            axios.post('/logout')
            .then(response =>{
                resole(response)
            })
            .catch(error=>{
                reject(error)
            })
        })
    }
  }
